import React, { useState } from "react";
import { useSelector } from "react-redux";
import { AppState } from "../../store/";

import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

import { media } from "../../styles/media";
import StyleBackgroundSvg from "./StyleBackgroundSvg";
import { IChatBotLauncher } from "./index";

interface IColor {
  settingColor: string;
  svgColor: string;
}

const HeaderText = styled.div<IColor>`
  position: absolute;
  top: 0.4em;
  right: 1.3em;
  font-size: 3em;
  line-height: 1.2;
  color: ${props => (props.svgColor === "#fff" ? props.settingColor : "#fff")};
  text-align: right;
`;

const HeaderIcon = styled.div<IColor>`
  cursor: pointer;
  z-index: 1000000;
  color: ${props => (props.svgColor === "#fff" ? props.settingColor : "#fff")};
  position: absolute;
  right: 0.6em;
  top: 0.5em;
  border: 2px solid #fff;

  font-size: 1.2em;
  padding: 0.3em 0.5em;
  display: flex;
  justify-content: center;
  align-items: center;

  & path {
    pointer-events: none;
  }
`;

const ImageContainer = styled.div<{ img: string } & IColor>`
  position: absolute;
  top: 3em;
  left: -6em;
  width: 13em;
  height: 13em;
  border: 3px solid
    ${props => (props.svgColor === "#fff" ? props.settingColor : "#fff")};
  border-radius: 50%;
  background: url(${props => props.img}) center/cover no-repeat;
  overflow: hidden;
`;

const OpenChatBotContainer = styled.div<IColor>`
  position: absolute;
  bottom: 5em;
  right: 1.2em;

  display: flex;
  justify-content: center;
  align-items: center;
  height: 1.8em;
  width: 59%;
  margin: 0 auto;
  border: 2px solid
    ${props => (props.svgColor === "#fff" ? props.settingColor : "#fff")};
  color: ${props => (props.svgColor === "#fff" ? props.settingColor : "#fff")};
  cursor: pointer;
  // transition: 0.4s ease;
`;

const OpenText = styled.div<IColor>`
  font-size: 1em;
  color: ${props => (props.svgColor === "#fff" ? props.settingColor : "#fff")};
`;

const Container = styled.div<{ baseSize: number; settingColor: string }>`
  font-size: ${props => props.baseSize}px;
  ${media.phone} {
    font-size: 10px;
  }
	margin-left: 5.5em;
	width: 22em;
  height: 16em;
  position: relative;
  cursor: pointer;
  }
`;

const StyleB: React.FC<IChatBotLauncher> = ({
  baseFontSize,
  color,
  query,
  showChatBot,
  toggleCloseDialog,
  openText,
  guideTitleB
}) => {
  const [svgColor, setSvgColor] = useState(color);
  const launcherImageUrl = useSelector(
    (state: AppState) => state.chatSetting.launcherImage
  );

  React.useEffect(() => {
    setSvgColor(color);
  }, [color]);

  let baseSize = baseFontSize;
  if (window.outerWidth < 400) {
    // モバイル端末のため
    baseSize = 10;
  }

  const hoverSvgColor = () => {
    setSvgColor("#fff");
  };

  const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
    const target = e.target as HTMLDivElement;

    if (
      target.tagName !== "svg" &&
      target.id !== "launcher-container" &&
      target.id !== "launcher-container__header-icon"
      // target.tagName !== 'path'
    ) {
      showChatBot();
    }
  };

  return (
    <Container
      id="launcher-container"
      baseSize={baseSize}
      settingColor={color}
      onMouseEnter={() => hoverSvgColor()}
      onMouseLeave={() => setSvgColor(color)}
      onClick={handleClick}
    >
      <StyleBackgroundSvg
        id="launcher-container__background"
        width={baseSize * 22}
        fill={svgColor}
        stroke={color}
      />
      <ImageContainer
        id="launcher-container__img"
        img={launcherImageUrl + `?r=${query}`}
        settingColor={color}
        svgColor={svgColor}
      />
      <HeaderText
        id="launcher-container__txt"
        settingColor={color}
        svgColor={svgColor}
      >
        {guideTitleB}
      </HeaderText>
      <HeaderIcon
        id="launcher-container__header-icon"
        onClick={toggleCloseDialog}
        settingColor={color}
        svgColor={svgColor}
      >
        <FontAwesomeIcon icon={faTimes} />
      </HeaderIcon>

      <OpenChatBotContainer
        id="launcher-container__open-txt-container"
        settingColor={color}
        svgColor={svgColor}
      >
        <OpenText
          id="launcher-container__open-txt"
          settingColor={color}
          svgColor={svgColor}
        >
          {openText}
        </OpenText>
      </OpenChatBotContainer>
    </Container>
  );
};

export default StyleB;
